<template>
  <div class="breadcrumbs p-3">
    <a href="/">Αρχική</a> / <strong>Προσωπικά Στοιχεία</strong>
  </div>
  <div class="login-wrapper">
    <div class="card shadow-none px-xl-5">
      <h3>Προσωπικά Στοιχεία</h3>

      <form @submit.prevent="saveProfile">
        <div class="field">
          <label>Όνομα</label>
          <input v-model="profile.name" type="text" required />
        </div>

        <div class="field">
          <label>Επώνυμο</label>
          <input v-model="profile.surname" type="text" required />
        </div>

        <div class="field">
          <label>Τηλέφωνο</label>
          <input v-model="profile.mobile" type="tel" required />
        </div>

        <div class="field">
          <label>Email</label>
          <input v-model="profile.email" type="email" disabled />
        </div>

        <div class="btn-wrap">
          <button class="btn btn-primary" type="submit">Αποθήκευση</button>
        </div>
      </form>
    </div>
  </div>
</template>




<script setup>
import { reactive, watch, onMounted } from 'vue';
import { useToast } from 'vue-toastification';
import { useStore } from 'vuex';
import { updateProfile, fetchUserInfo } from '@/services/user';
import { useRouter } from 'vue-router';


const toast = useToast();
const store = useStore();
const router = useRouter();

const profile = reactive({
  name: '',
  surname: '',
  mobile: '',
  email: '',
});

// Watch the store.userInfo in case it changes
watch(
  () => store.state.userInfo,
  (user) => {
    console.log('Watcher triggered, store.userInfo:', user);
    if (user) {
      profile.name = user.name || '';
      profile.surname = user.surname || '';
      profile.mobile = user.mobile || '';
      profile.email = user.email || '';
    }
  },
  { immediate: true }
);

// On mount, fetch user data and store it
onMounted(async () => {
  const response = await fetchUserInfo();
  if (response.data?.info) {
    store.commit('setUserInfo', response.data.info);
  }
});

// Save profile function
async function saveProfile() {
  const payload = {
    name: profile.name,
    surname: profile.surname,
    mobile: profile.mobile,
  };

  const res = await updateProfile(payload);

  if (res.success) {
    toast.success(res.message);
    window.location.reload();
  } else {
    toast.error(res.message);
  }
}
</script>



<style scoped>
.login-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

.card {
  max-width: 400px;
  padding: 20px;
  background: #fff;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
  width: 100%;
}

.field {
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;
}

label {
  font-size: 0.9rem;
  margin-bottom: 4px;
}

input {
  padding: 8px 10px;
  border-radius: 6px;
  border: 1px solid #ccc;
}

.btn-wrap {
  text-align: center;
}

button {
  margin-top: 10px;
  padding: 10px;
  border-radius: 6px;
  border: none;
  color: #fff;
  cursor: pointer;
  width: 100%;
  max-width: 200px;
  font-weight: 700;
}
</style>
